var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":_vm.title,"type":_vm.type,"confirmText":_vm.confirmText,"cancelText":_vm.cancelText},on:{"close":function($event){return _vm.$emit('close')},"confirm":function($event){return _vm.$emit('confirm')}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }